import { useContext, useMemo } from "react";
import { Route, Routes } from "react-router-dom";
import { observer } from "mobx-react";
import { TableController } from "../../../../../stores/models/TableController";
import { OptionCollection } from "../../../../../stores/models/OptionCollection";
import { RootContext } from "../../../../../stores";
import AdministratorsOverview from "./AdministratorsOverview";
import { IAdministratorOverview } from "../../../../../stores/models/interfaces/IAdministratorOverview";
import { IAPIGetRequestParameters } from "../../../../../stores/models/APIGetRequestParameters";
import { IOrganizationAdminInvite } from "../../../../../stores/models/OrganizationAdminInvite";

const AdministratorsSection = observer(() => {

    /********* React hooks *********/

    const rootStore = useContext(RootContext);
    const userStore = rootStore.userStore;
    const organizationStore = rootStore.organizationStore;
    const invitationStore = rootStore.invitationStore;
    const tableController = useMemo(() => new TableController<'email', IAdministratorOverview, IOrganizationAdminInvite>({
        records: new OptionCollection('email', [] as IAdministratorOverview[]),
        loadRecords: (request: IAPIGetRequestParameters<keyof IAdministratorOverview>) => organizationStore.getAdmins(userStore.user.organization?.id || -1, request),
        addRecord: invitationStore.postAdminInvite,
        deleteRecords: organizationStore.deleteAdmins,
    }), []);

    /********* Render *********/

    return (
        <Routes>
            {/* <Route path={volunteerIdParam} element={<VolunteerDetailsPage />} /> */}
            <Route
                path="/"
                element={
                    <AdministratorsOverview tableController={tableController} />
                }
            />
        </Routes>
    );
});

export default AdministratorsSection;